import { createContext } from 'react';
import type { ActorRefFrom } from 'xstate';
import type { MachineContext, searchMachine } from '../search.machine';

export type SearchContext = {
  lang: 'ru' | 'en';
  send: ActorRefFrom<typeof searchMachine>['send'];
  historyEnabled?: boolean;
  activeDescendant: MachineContext['activeDescendant'];
  activeRow: MachineContext['activeRow'];
};

export const searchContext = createContext<SearchContext>({
  lang: 'ru',
  send() {
    /* noop */
  },
  activeDescendant: undefined,
  activeRow: undefined,
  historyEnabled: false,
});

// @ts-expect-error -- Технически у провайдера не может быть displayName, но если не проставить, Storybook показывает дичь.
searchContext.Provider.displayName = 'SearchContext';
